function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "day-cloudy");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "24.3617045%",
  y1: "72.8710337%",
  x2: "63.6421593%",
  y2: "39.9796521%",
  id: "linearGradient-1"
}, React.createElement("stop", {
  stopColor: "#F2F2F2",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#CFCFCF",
  offset: "100%"
})), React.createElement("linearGradient", {
  x1: "72.5161778%",
  y1: "64.8727273%",
  x2: "8.62380839%",
  y2: "22.6545455%",
  id: "linearGradient-2"
}, React.createElement("stop", {
  stopColor: "#FFFFFF",
  offset: "2%"
}), React.createElement("stop", {
  stopColor: "#FFFFFF",
  stopOpacity: 0,
  offset: "100%"
})));

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "day-cloudy",
  transform: "translate(0.000000, 2.000000)"
}, React.createElement("circle", {
  id: "Oval",
  fill: "#EFCC00",
  fillRule: "nonzero",
  cx: 84.5,
  cy: 49.4446841,
  r: 31.5
}), React.createElement("path", {
  d: "M84,-0.0553158818 L84,10.9446841",
  id: "Path",
  stroke: "#EFCC00",
  strokeWidth: 3,
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M84,87.9446841 L84,98.9446841",
  id: "Path",
  stroke: "#EFCC00",
  strokeWidth: 3,
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M34,49.9446841 L45,49.9446841",
  id: "Path",
  stroke: "#EFCC00",
  strokeWidth: 3,
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M123,49.9446841 L134,49.9446841",
  id: "Path",
  stroke: "#EFCC00",
  strokeWidth: 3,
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M49,14.9446841 L57,22.9446841",
  id: "Path",
  stroke: "#EFCC00",
  strokeWidth: 3,
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M112,76.9446841 L120,84.9446841",
  id: "Path",
  stroke: "#EFCC00",
  strokeWidth: 3,
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M49,84.9446841 L57,76.9446841",
  id: "Path",
  stroke: "#EFCC00",
  strokeWidth: 3,
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M112,22.9446841 L120,14.9446841",
  id: "Path",
  stroke: "#EFCC00",
  strokeWidth: 3,
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M43.6759917,34.9446841 C59.8900952,34.9120269 74.7864611,43.8329661 82.3604414,58.1116072 C94.8397967,50.8446293 110.55339,52.1457401 121.656555,61.3653887 C132.75972,70.5850372 136.871287,85.7459907 131.938648,99.2794764 C127.006009,112.812962 114.08701,121.816608 99.6311764,121.795541 L43.6759917,121.944684 C19.5544075,121.944684 0,102.469091 0,78.444729 C0,54.4203672 19.5544075,34.9446841 43.6759917,34.9446841 Z",
  id: "Path",
  fill: "url(#linearGradient-1)",
  fillRule: "nonzero"
}), React.createElement("ellipse", {
  id: "Oval",
  fill: "url(#linearGradient-2)",
  fillRule: "nonzero",
  transform: "translate(99.372837, 87.180572) rotate(-74.390000) translate(-99.372837, -87.180572) ",
  cx: 99.3728371,
  cy: 87.1805719,
  rx: 34.1705349,
  ry: 34.2478481
})));

var SvgDayCloudy = function SvgDayCloudy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "136px",
    height: "124px",
    viewBox: "0 0 136 124",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDayCloudy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/day-cloudy.33e57fe8.svg";
export { ForwardRef as ReactComponent };